import { useEffect, useState } from 'react';
import { Duration } from 'luxon';
export function useLocationEligibility(_a) {
    var currentWeekProgress = _a.currentWeekProgress, siteEligibilitiesPerWeek = _a.siteEligibilitiesPerWeek, selectedWeek = _a.selectedWeek;
    var _b = useState([]), siteEligibilitiesForWeek = _b[0], setSiteEligibilitiesForWeek = _b[1];
    var _c = useState(null), totalDurationForWeek = _c[0], setTotalDurationForWeek = _c[1];
    var _d = useState(null), scheduledDurationForWeek = _d[0], setScheduledDurationForWeek = _d[1];
    var _e = useState(null), workedDurationForWeek = _e[0], setWorkedDurationForWeek = _e[1];
    useEffect(function () {
        var _a = siteEligibilitiesPerWeek[selectedWeek], totalScheduledDuration = _a.totalScheduledDuration, siteEligibilities = _a.siteEligibilities;
        setSiteEligibilitiesForWeek(siteEligibilities);
        // If future week is selected, use siteEligibilitiesPerWeek data
        if (selectedWeek !== 1) {
            setTotalDurationForWeek(totalScheduledDuration);
            setScheduledDurationForWeek(totalScheduledDuration);
            setWorkedDurationForWeek(Duration.fromMillis(0));
            return;
        }
        if (!currentWeekProgress) {
            // TODO: show some error or default UI?
            return;
        }
        // If current week is selected, use data from currentWeekProgress query
        var workedDuration = currentWeekProgress.workedDuration, upcomingScheduledDuration = currentWeekProgress.upcomingScheduledDuration;
        // Convert to duration
        var scheduledDuration = Duration.fromISO(upcomingScheduledDuration.value);
        var pastScheduledDuration = Duration.fromISO(workedDuration.value);
        var totalDuration = scheduledDuration.plus(pastScheduledDuration);
        setTotalDurationForWeek(totalDuration);
        setScheduledDurationForWeek(scheduledDuration);
        setWorkedDurationForWeek(pastScheduledDuration);
    }, [currentWeekProgress, siteEligibilitiesPerWeek, selectedWeek]);
    return {
        totalDurationForWeek: totalDurationForWeek,
        scheduledDurationForWeek: scheduledDurationForWeek,
        workedDurationForWeek: workedDurationForWeek,
        siteEligibilitiesForWeek: siteEligibilitiesForWeek
    };
}
